import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addConstruction } from "../../../store/actions"
import { useEffect } from "react"

const AddConstruction = props => {
  const dispatch = useDispatch()
  document.title = "Add construction"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      construction: "",
    },
    validationSchema: Yup.object({
      construction: Yup.string().required(
        "Please Enter Construction"
      ),
    }),
    onSubmit: values => {
      dispatch(addConstruction(values, props.history))
    },
  })

  const constructs = useSelector(state => state.construction)
  const { error } = useSelector(state => ({
    error: state.construction.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Construction" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formCo"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="constsc">
                            Construction
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="construction"
                            className={
                              validation.touched.construction &&
                              validation.errors.construction
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="constsc"
                            placeholder="Enter Construction"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.construction || ""}
                          />
                          {validation.touched.construction &&
                          validation.errors.construction ? (
                            <FormFeedback type="invalid">
                              {validation.errors.construction}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {constructs && constructs.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddConstruction
